import { cva } from 'class-variance-authority'

export const rootStyles = cva('mx-auto flex justify-center')

export const contentStyles = cva('flex flex-row items-center gap-1')

export const itemStyles = cva(
  '' // Empty base style since PaginationItem only uses mtc utility
)

export const linkStyles = cva('gap-1', {
  variants: {
    direction: {
      previous: 'pl-2.5',
      next: 'pr-2.5',
    },
  },
})

export const ellipsisStyles = cva('flex h-9 w-9 items-center justify-center')

export const pagesContainerStyles = cva('flex flex-row items-center gap-1')

export const ellipsisBreakStyles = cva('px-2')
